import { render, staticRenderFns } from "./select-birthday.vue?vue&type=template&id=4ad9dc80"
import script from "./select-birthday.vue?vue&type=script&lang=js"
export * from "./select-birthday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports